import { Component, input, computed } from '@angular/core';
import { environment } from '../../../environments/environment';
import { getCategoryLabel } from '../../enums/category.enum';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-card',
  imports: [RouterLink, TranslateModule],
  templateUrl: './card.component.html',
  styleUrl: './card.component.css'
})
export class CardComponent {
  denominacion = input.required<string>();
  categoria = input.required<string>();
  OBJECTID = input.required<number>();
  image = input.required<string>();
  customRoute = input<string[] | null>(null);
  isDevelop = environment.develop;

  categoriaLabel = computed(() => getCategoryLabel(this.categoria()));
  cardRoute = computed(() => this.customRoute() || ['/ficha', this.OBJECTID()]);
}